import { useMutation, UseMutationOptions } from 'react-query';

import { ApiResponse, ApiError, post } from 'services/api';
import { NBAServiceListResponse } from 'modules/ai/nba/types';

export const updateNBAService = '/lists/subscribeNextBestAction';

export type UpdateNBAServiceParams = {
  campaignId: number;
  listId: number;
};
export const createUpdateNBAService = ({ campaignId, listId }: UpdateNBAServiceParams) => {
  return post(updateNBAService, {
    listId,
    campaignId,
  });
};
export const useUpdateNBAService = () => {
  return useMutation({
    mutationFn: createUpdateNBAService,
  } as UseMutationOptions<ApiResponse<NBAServiceListResponse>, ApiError, UpdateNBAServiceParams>);
};
